export class NotificacaoDetalhe {
  id_controle_envio_notificacao: number;
  data_cadastro: Date;
  data_inicio_envio: Date;
  data_fim_envio: Date;
  agendamento: boolean;
  data_agendamento?: any;
  status: string;
  titulo: string;
  mensagem: string;
  usuarios: string;
  tipo_notificacao: number;
  id_empresa: number;
  id_notificacao: number;
  id_segmento_notificacao?: any;
  segmento_notificacao?: SegmentoNotificacao;
  constructor() {
    this.segmento_notificacao = new SegmentoNotificacao();
  }
}
export class UsuarioNotificacao {
  url: string;
  id_usuarios: number;
  nome: string;
}
export class Row {
  id_notificacao_usuario: number;
  visualizado: boolean;
  data_visualizado?: any;
  data_cadastro: Date;
  id_usuarios: number;
  id_notificacao: number;
  usuario_notificacao: UsuarioNotificacao;

  constructor() {
    this.usuario_notificacao = new UsuarioNotificacao();
  }
}

export class Dados {
  count: number;
  rows: Row[];
  constructor() {
    this.rows = new Array<Row>();
  }
}

export class RootDetailNotification {
  notificacao: NotificacaoDetalhe;
  dados: Dados;
  usuarios: string;
  constructor() {
    this.notificacao = new NotificacaoDetalhe();
    this.dados = new Dados();
  }
}


export class SegmentoNotificacao {
  id_segmento_notificacao: number;
  nome: string;
  referencia: string;
  data_cadastro: Date;
  data_desativacao?: any;
  restrito: boolean;
}
